import { ElNotification } from 'element-plus'
import { Refresh } from '@element-plus/icons-vue'
import { NotificationState } from "../Notification"

const QweNotification = {
    [NotificationState.Wait]:function(options:any){
        let option = {
            ...options,
            "icon": Refresh
        }
        return ElNotification(option);
    },

    [NotificationState.Info]:function(options:any){
        let option = {
            ...options,
            "type":"info"
        };
        return ElNotification(option);
    },

    [NotificationState.Success]:function(options:any){
        let option = {
            ...options,
            "type":"success"
        };
        return ElNotification(option);
    },

    [NotificationState.Warn]:function(options:any){
        let option = {
            ...options,
            "type":"warning"
        };
        return ElNotification(option);
    },

    [NotificationState.Error]:function(options:any){
        let option = {
            ...options,
            "type":"error"
        };
        return ElNotification(option);
    },
}

export default QweNotification